import i18n from './index';

/** Локаль для Intl/toLocale*: текущий язык интерфейса. */
export const locale = () => i18n.language || undefined;

export const formatDate = (value, options) =>
  value ? new Date(value).toLocaleDateString(locale(), options) : '';

export const formatDateTime = (value, options) =>
  value ? new Date(value).toLocaleString(locale(), options) : '';

export const formatNumber = (value, options) =>
  value === null || value === undefined || value === '' ? '' : Number(value).toLocaleString(locale(), options);
